import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

// Fallback logos for testing or if no JSON available
const defaultLogos = Array(8).fill("placeholder");

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadClients = async () => {
      try {
        const response = await fetch('/clients.json');
        if(response.ok) {
          const data = await response.json();
          setClients(data.clients && data.clients.length > 0 ? data.clients : defaultLogos);
        } else {
          setClients(defaultLogos);
        }
      } catch (error) {
        setClients(defaultLogos);
      } finally {
        setLoading(false);
      }
    };
    loadClients();
  }, []);

  if (loading) return null;

  return (
    <section id="clients" className="py-16 bg-light border-y border-dark/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 text-center">
        <h3 className="text-xl font-semibold text-dark/60 uppercase tracking-widest font-barlow">
          Trusted By Industry Leaders & Certified By
        </h3>
      </div>
      
      {/* Marquee Container */}
      <div className="relative w-full overflow-hidden bg-white/50 py-8 shadow-inner">
        {/* Gradient Fades for Marquee */}
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-light to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-light to-transparent z-10 pointer-events-none" />
        
        <motion.div
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            repeat: Infinity,
            ease: "linear",
            duration: 30,
          }}
          className="flex items-center gap-16 whitespace-nowrap w-max"
        >
          {/* Double the array for seamless looping */}
          {[...clients, ...clients].map((client, index) => (
            <div 
              key={index} 
              className="w-40 h-20 flex-shrink-0 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-500 opacity-60 hover:opacity-100"
            >
              {client === 'placeholder' ? (
                <div className="text-2xl font-bold text-dark/30 font-barlow">CLIENT LOGO</div>
              ) : (
                <img
                  src={`/clients/${client}`}
                  alt={`Client Logo ${index}`}
                  className="max-w-full max-h-full object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
              )}
              {client !== 'placeholder' && (
                <div className="hidden text-xl font-bold text-dark/30 font-barlow">ISO / CE</div>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Clients;
